import React from 'react';

const RefreshContext = React.createContext();

// The refresh context will update refreshKey whenever a full data refresh
// is needed. Examples inlcude a change in time range, updated category or
// a new data view that must update the nav.
export function RefreshProvider({ children }) {
  const [refreshKey, setRefreshKey] = React.useState(0);

  const refresh = () => {
    setRefreshKey(oldKey => oldKey + 1);
  };

  return (
    <RefreshContext.Provider value={{ refreshKey, refresh }}>
      {children}
    </RefreshContext.Provider>
  );
}
export default RefreshContext;
